"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GgGridTreeDataGroupingCell;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@gogame/ui/Box"));
var _Icon = require("@gogame/ui/Icon");
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _Components = require("./Components");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var GgGroupingCell = function GgGroupingCell(_ref) {
  var _ref$formattedValue = _ref.formattedValue,
    formattedValue = _ref$formattedValue === void 0 ? {} : _ref$formattedValue,
    _ref$colDef = _ref.colDef,
    colDef = _ref$colDef === void 0 ? {} : _ref$colDef,
    filteredDescendantCount = _ref.filteredDescendantCount;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var value = formattedValue.value,
    valueColor = formattedValue.valueColor,
    icon = formattedValue.icon,
    tooltip = formattedValue.tooltip;
  var align = colDef.align,
    dotted = colDef.dotted,
    placeholder = colDef.placeholder,
    disableText = colDef.disableText;
  var handleMoveEnter = (0, _react.useCallback)(function () {
    setTouched(true);
  }, [setTouched]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Components.CellWrapper, {
    "data-cy": _constants.dataCy,
    onMouseEnter: handleMoveEnter,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Components.CellValue, {
      icon: icon,
      value: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
        children: [value, filteredDescendantCount > 0 ? " (".concat(filteredDescendantCount, ")") : '']
      }),
      dotted: dotted,
      lineClamp: 2,
      tooltip: touched && tooltip,
      dataCy: _constants.dataCyValue,
      placeholder: placeholder,
      color: valueColor,
      disableText: disableText,
      align: align
    })
  });
};
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['treeDataGroupingCell'],
    toggle: ['treeDataGroupingCellToggle']
  };
  return (0, _composeClasses["default"])(slots, _xDataGridPro.getDataGridUtilityClass, classes);
};
function GgGridTreeDataGroupingCell(props) {
  var _filteredDescendantCo, _rootProps$slotProps;
  var id = props.id,
    field = props.field,
    rowNode = props.rowNode,
    _props$offsetMultipli = props.offsetMultiplier,
    offsetMultiplier = _props$offsetMultipli === void 0 ? 1 : _props$offsetMultipli;
  var rootProps = (0, _xDataGridPro.useGridRootProps)();
  var apiRef = (0, _xDataGridPro.useGridApiContext)();
  var classes = useUtilityClasses(rootProps);
  var filteredDescendantCountLookup = (0, _xDataGridPro.useGridSelector)(apiRef, _xDataGridPro.gridFilteredDescendantCountLookupSelector);
  var filteredDescendantCount = (_filteredDescendantCo = filteredDescendantCountLookup[rowNode.id]) !== null && _filteredDescendantCo !== void 0 ? _filteredDescendantCo : 0;
  var Icon = rowNode.childrenExpanded ? _Icon.IndeterminateCheckBoxIcon : _Icon.AddBoxIcon;
  var handleClick = function handleClick(event) {
    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation(); // TODO remove event.stopPropagation
  };
  var hasChildren = filteredDescendantCount > 0;
  var firstLevelWithoutChildren = rowNode.depth === 0 && !hasChildren;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box["default"], {
    className: classes.root,
    sx: {
      ml: rowNode.depth * offsetMultiplier,
      height: '100%'
    },
    children: [!firstLevelWithoutChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        flex: '0 0 28px',
        alignSelf: 'stretch',
        marginRight: '8px',
        marginLeft: '-4px'
      },
      children: hasChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)(rootProps.slots.baseIconButton, _objectSpread(_objectSpread({
        size: 'small',
        onClick: handleClick,
        tabIndex: -1,
        "aria-label": rowNode.childrenExpanded ? apiRef.current.getLocaleText('treeDataCollapse') : apiRef.current.getLocaleText('treeDataExpand')
      }, rootProps === null || rootProps === void 0 || (_rootProps$slotProps = rootProps.slotProps) === null || _rootProps$slotProps === void 0 ? void 0 : _rootProps$slotProps.baseIconButton), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
          fontSize: 'inherit'
        })
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(GgGroupingCell, _objectSpread(_objectSpread({}, props), {}, {
      filteredDescendantCount: filteredDescendantCount
    }))]
  });
}